import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import { IActivityScheduleItemBase } from '../../models/activities';

interface IUpdateActivityItemProps {
  itemId: string;
  description?: string;
  isActive: boolean;
  isRequired: boolean;
  isVerified: boolean;
  name: string;
  price?: number;
  totalAmount: number;
  userId?: string;
  costCenter?: string;
  productCode?: string;
  productType?: string;
  productNature?: string;
  invoiceType?: 'NF' | 'ND';
}

export type IUpdatedActivityScheduleItem = IActivityScheduleItemBase;

export const updateActivityScheduleItemsService = async ({
  itemId,
  description,
  isActive,
  isRequired,
  isVerified,
  name,
  price,
  totalAmount,
  userId,
  costCenter,
  productCode,
  productType,
  productNature,
  invoiceType,
}: IUpdateActivityItemProps): Promise<IUpdatedActivityScheduleItem> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedActivityScheduleItem>(
    `/activities/schedules/items/${itemId}`,
    {
      description,
      isActive,
      isRequired,
      name,
      price,
      totalAmount,
      userId,
      costCenter,
      productCode,
      productType,
      productNature,
      invoiceType,
    },
    { params: { isVerified } },
  );

  return data;
};
